module.exports = __webpack_public_path__ + "static/media/room.47f6d63b.hdr";